<template>
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          <img
            class="arrow-left"
            src="@/assets/img/arrow-left.svg"
            alt=""
            @click="pushBack"
          />
          <span class="ml20">编辑草稿</span>
          <!-- 已经发布 publish_status === 1   未发布 publish_status != 1 -->
          <v-button
            class="flr"
            type="primary"
            name="showPublish"
            @click="showPublishModel()"
            >{{ "发布物模型" }}</v-button
          >
        </div>
      </div>
      <div class="main-center">
        <!-- <v-button class="" type="info" name="" @click="showModel"
          >物模型TSL</v-button
        > -->
        <v-button class="" type="primary" name="" @click="showAddModel"
          >添加自定义功能</v-button
        >
        <v-button class="" type="primary" name="" @click="showAddCommonModel">添加公共功能</v-button>
        <v-button class="" type="primary" name="" @click="importModelVisible = true">导入物模型</v-button>
      </div>
      <vxe-table
        row-id="id"
        :data="infoData"
        align="left"
        :sort-config="{
          defaultSort: { field: 'function_typeView', order: 'asc' },
        }"
      >
        <vxe-table-column
          field="name"
          show-overflow
          min-width="80"
          title="功能名称"
        ></vxe-table-column>
        <!-- <vxe-table-column
          sortable
          field="function_typeView"
          show-overflow
          min-width="80"
          title="功能类型"
        ></vxe-table-column> -->
        <vxe-column title="功能类型" field="function_typeView" sortable show-overflow min-width="80">
          <template v-slot="slotProps">
            <span v-if="slotProps.row.function_typeView === '事件'" class="text-success" >{{slotProps.row.function_typeView}}</span>
            <span v-if="slotProps.row.function_typeView === '属性'" class="text-error" >{{slotProps.row.function_typeView}}</span>
            <span v-if="slotProps.row.function_typeView === '服务'" class="text-warn" >{{slotProps.row.function_typeView}}</span>
          </template>
        </vxe-column>
        <vxe-table-column
          field="identifier"
          show-overflow
          min-width="100"
          title="功能唯一标识"
        ></vxe-table-column>
        <vxe-table-column
          field="data_type"
          show-overflow
          min-width="80"
          title="数据类型"
        ></vxe-table-column>
        <vxe-column
          field="model_type"
          show-overflow
          min-width="80"
          title="物模型类型"
        >
          <template v-slot="slotProps">
            <span v-if="slotProps.row.model_type === 'COMMON'" class="text-success" >公共物模型</span>
            <span v-if="slotProps.row.model_type === 'PRODUCT'" class="text-warn" >产品物模型</span>
          </template>
        </vxe-column>
        <vxe-table-column
          field="desc"
          show-overflow
          min-width="280"
          title="备注"
        ></vxe-table-column>
        <vxe-column title="操作" min-width="140">
          <template v-slot="slotProps">
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn2"
                slot="reference"
                @click="openViewModel(slotProps.row)"
                >编辑</v-button
              ></span
            >
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn2"
                slot="reference"
                @click="openDelModel(slotProps.row)"
                >删除</v-button
              ></span
            >
          </template>
        </vxe-column>
      </vxe-table>
    </div>

    <v-pagination
      v-if="total"
      @change-page="changePage"
      @change-size="changeSize"
      :total="total"
      name="page-basic"
      is-show-total
      is-change-size
      is-input-page
      :current-page="this.currentPage"
    ></v-pagination>

    <AddPhysicalmodel
      :showInputDialog.sync="addloading"
      ref="add"
      :productId="productId"
      :productKey="productKey"
      @getData="getData"
    ></AddPhysicalmodel>

    
    <AddCommonPhysicalmodel
      :showInputDialog.sync="addCommonloading"
      ref="addCommon"
      :productId="productId"
      :productKey="productKey"
      @getData="getData"
    ></AddCommonPhysicalmodel>

    <ImportPhysicalModel
      :showInputDialog.sync="importModelVisible"
      ref="importModel"
      :productId="productId"
      :productKey="productKey"
      @getData="getData"
    ></ImportPhysicalModel>

    <UpdataAndview
      :showInputDialog.sync="UpdataAndviewloading"
      ref="UpdataAndview"
      :updataOrview="updataOrview"
      :id="id"
      :functiontype="functiontype"
      @getData="getData"
    ></UpdataAndview>
    <Model
      :showInputDialog.sync="Modelloading"
      ref="Model"
      :productKey="productKey"
    ></Model>
    <Del
      :showInputDialog.sync="Delloading"
      ref="del"
      :id="id"
      @getData="getData"
    ></Del>
    <publishModel
      :showInputDialog.sync="publishModelloading"
      ref="publishModel"
      :productId="productId"
      :productKey="productKey"
      @getData="getData"
    ></publishModel>
  </div>
</template>

<script>
import ImportPhysicalModel from "@/components/product/physicalmodel/import-physicalmodel.vue";
import AddCommonPhysicalmodel from "@/components/product/physicalmodel/add-common-physicalmodel.vue";
import AddPhysicalmodel from "@/components/product/physicalmodel/add-physicalmodel.vue";
import UpdataAndview from "@/components/product/physicalmodel/updataAndview-physicalmodel.vue";
import Model from "@/components/product/physicalmodel/model.vue";
import Del from "@/components/product/physicalmodel/del.vue";
import publishModel from "@/components/product/publishModel.vue";
import { FUNCTION_TYPE } from "@/common/libs/Contains";
export default {
  components: { ImportPhysicalModel, AddCommonPhysicalmodel, AddPhysicalmodel, UpdataAndview, Model, Del, publishModel },
  props: { },
  data() {
    return {
      table: [],
      addloading: false,
      addCommonloading: false,
      importModelVisible: false,
      UpdataAndviewloading: false,
      Modelloading: false,
      Delloading: false,
      publishModelloading: false,
      updataOrview: 1, //1为编辑 2为查看
      id: 0,
      functiontype: "",
      infoData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      productName:'',
      productKey:''
    };
  },
  created() {
    this.productName = this.$route.query.productName
    this.productKey = this.$route.query.productKey
    this.productId = this.$route.query.productId
    this.getData();
  },

  methods: {
    async getData() {
      const subData = {
        product_id: Number(this.productId),
        product_key: this.productKey,
        page_num: this.currentPage,
        page_size: this.pageSize,
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/thing/draft/page/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.infoData = res.data.list;
        this.total = res.data.page.total;
        this.infoData.map((item) => {
          item.function_typeView = FUNCTION_TYPE[item.function_type];
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1
      this.getData();
    },
    openViewModel(row) {
      this.updataOrview = 1;
      this.id = row.ID;
      this.functiontype = row.function_type;
      this.UpdataAndviewloading = !this.UpdataAndviewloading;
    },
    showAddModel() {
      this.addloading = !this.addloading;
    },
    showAddCommonModel() {
      this.addCommonloading = !this.addCommonloading;
    },
    openDelModel(row) {
      this.id = row.ID;
      this.Delloading = !this.Delloading;
    },
    showModel() {
      this.Modelloading = !this.Modelloading;
    },
    showDraftModel() {},
    pushBack () {
        //跳转路由-该产品的详情页面
        this.$router.push({
        name: "/deviceInfo-manage/product-details-info",
        query: { name: this.productName, key: this.productKey, id: this.productId, activeName: '3'},
      });
    },
    showPublishModel () {
      this.publishModelloading = !this.publishModelloading
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
